import { render, staticRenderFns } from "./Infopoints.vue?vue&type=template&id=773507b6"
import script from "./Infopoints.vue?vue&type=script&lang=js"
export * from "./Infopoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports